export async function fileSave(blob, options) {
    const { fileName } = options;
    const aTag = document.createElement('a');
    const blobUrl = URL.createObjectURL(blob);
    aTag.href = blobUrl;
    aTag.download = fileName;
    aTag.click();
    URL.revokeObjectURL(blobUrl);
    aTag.remove();
}